import React from 'react';
import './CourseCard.css';

const CourseCard = ({ course }) => {
  const handleClick = () => {
    // Placeholder for navigation to CourseOverviewPage
    alert(`Navigate to course: ${course.title}`);
  };

  return (
    <div className="course-card" tabIndex={0} role="button" aria-pressed="false" onClick={handleClick} onKeyPress={e => { if (e.key === 'Enter') handleClick(); }}>
      <div className="course-thumbnail" aria-label="Course thumbnail">
        {/* Placeholder image */}
        <div className="thumbnail-placeholder">Image</div>
      </div>
      <div className="course-info">
        <h3 className="course-title">{course.title}</h3>
        <p className="course-desc">{course.description}</p>
        <div className="course-meta">
          <span className="course-instructor">{course.instructor}</span>
          <span className="course-rating">⭐ {course.rating}</span>
        </div>
        <div className="course-price">{course.price}</div>
      </div>
    </div>
  );
};

export default CourseCard; 